import type { TooltipProps } from '@mui/material/Tooltip';

/** Tooltip coerente e leggibile (sfondo scuro + testo chiaro) per icone info su Retention. */
export const retentionHelpTooltipComponentsProps = {
  tooltip: {
    sx: {
      bgcolor: 'rgba(15, 23, 42, 0.94)',
      color: '#f1f5f9',
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.45,
      maxWidth: 300,
      px: 1.25,
      py: 1,
      boxShadow: '0 12px 32px -10px rgba(15, 23, 42, 0.55)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
    },
  },
  arrow: {
    sx: { color: 'rgba(15, 23, 42, 0.94)' },
  },
} satisfies NonNullable<TooltipProps['componentsProps']>;
